"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right2"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left2"));
var _calendar = _interopRequireDefault(require("cccisd-icons/calendar2"));
var _circleSmall = _interopRequireDefault(require("cccisd-icons/circle-small"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _checkmarkCircle = _interopRequireDefault(require("cccisd-icons/checkmark-circle"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tabs = _interopRequireDefault(require("./Tabs/tabs.js"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _types = _interopRequireDefault(require("./types"));
var _moment = _interopRequireDefault(require("moment"));
var _Toggle = _interopRequireDefault(require("./Toggle"));
require("./toggle.scss");
var _CalendarDialog = _interopRequireDefault(require("./CalendarDialog.js"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
require("react-widgets/dist/css/react-widgets.css");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var appDefs = window.cccisd.appDefs;
var sessions;
if (appDefs.sessions && !Array.isArray(appDefs.sessions) && appDefs.sessions.fixedSettings) {
  sessions = appDefs.sessions.fixedSettings.sessions;
}

/** Components to support IMPACT features */
var DataCollection = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DataCollection, _React$Component);
  function DataCollection(_props) {
    var _this;
    _classCallCheck(this, DataCollection);
    _this = _callSuper(this, DataCollection, [_props]);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.examineProps(_this.props);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      _this.examineProps(nextProps);
    });
    _defineProperty(_assertThisInitialized(_this), "examineProps", function (props) {
      var calendarOpen = false;
      var notSubmitted = false;
      var calendarDate = (0, _moment["default"])();
      var sessionDate = null;

      // if requireCalendarPicker prop and the session has not been started, open calendar
      if (props.requireCalendarPicker && props.session.date === null) {
        notSubmitted = true;
        calendarOpen = true;
      }
      if (props.session.date) {
        calendarDate = (0, _moment["default"])(props.session.date, 'MM/DD/YYYY');
        sessionDate = (0, _moment["default"])(props.session.date, 'MM/DD/YYYY');
      }
      _this.setState({
        calendarOpen: calendarOpen,
        notSubmitted: notSubmitted,
        calendarDate: calendarDate,
        sessionHeld: notSubmitted ? null : props.session.held,
        sessionDate: sessionDate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "jumpToSession", function (event) {
      _this.props.onJumpToSession(event);
    });
    _defineProperty(_assertThisInitialized(_this), "goToNext", function () {
      _this.props.onFlipperForward();
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextActivity", function () {
      _this.props.onNextActivityClick();
    });
    _defineProperty(_assertThisInitialized(_this), "goToPrevious", function () {
      _this.props.onFlipperBack();
    });
    _defineProperty(_assertThisInitialized(_this), "onActivityFinished", function (flowObj) {
      _this.props.onActivityFinished(flowObj);
    });
    _defineProperty(_assertThisInitialized(_this), "onFlowComplete", function (flowObj) {
      // if (this.props.isScrollTop) {
      //     this.dataEntryDiv.scrollTop = 0;
      //     // this is a hardcoded value
      //     // this number gives a rough guess and assumes in most cases
      //     // your app will have a navbar, subnav, and an h1 of standard height
      //     // on your data entry page
      //     window.scrollTo({ top: 200, behavior: 'smooth' });
      // }
      _this.props.onFlowFinished(flowObj);
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectTab", function (tab) {
      _this.props.onActivitySelect(tab);
    });
    _defineProperty(_assertThisInitialized(_this), "onCalendarClick", function () {
      _this.setState({
        calendarOpen: !_this.state.calendarOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onDateSelect", function (startDate, endDate) {
      _this.setState({
        calendarDate: startDate.startDate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCalendarSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.props.onCalendarSubmit({
              session: _this.props.session,
              held: _this.state.sessionHeld,
              date: _this.state.calendarDate
            });
          case 2:
            _this.setState({
              calendarOpen: false
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "formatTitle", function (title, activity) {
      var allChildrenCompleteBool = false;
      var checkChildrenBool = false;
      if ('acrossChildren' in activity && !('flowUserLists' in activity.acrossChildrenSettings)) {
        checkChildrenBool = true;
        allChildrenCompleteBool = (0, _cccisdLaravelAppdefs.allChildrenComplete)(activity, _this.props.pawn, _this.props.session);
      }
      if (_this.props.showActivityApplicable && _this.props.showActivityComplete) {
        var status = '';
        if (activity.progress.completed || checkChildrenBool && allChildrenCompleteBool) {
          status = /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              fontSize: '1.3em',
              color: 'currentColor'
            }
          }, /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], null));
        } else {
          status = /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
            checked: activity.applicable,
            onChange: _this.toggleChange.bind(null, activity),
            icons: true
          });
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '0.5em',
            width: '40px'
          }
        }, status), /*#__PURE__*/_react["default"].createElement("div", null, title));
      }
      if (_this.props.showActivityComplete) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '0.5em',
            width: '40px'
          }
        }, (activity.progress.completed || checkChildrenBool && allChildrenCompleteBool) && /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            fontSize: '1.3em',
            color: 'currentColor'
          }
        }, /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], null))), /*#__PURE__*/_react["default"].createElement("div", null, title));
      }
      if (_this.props.showActivityApplicable) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '0.5em'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
          checked: activity.applicable,
          onChange: _this.toggleChange.bind(null, activity),
          icons: true
        })), /*#__PURE__*/_react["default"].createElement("div", null, title));
      }

      // showActivityApplicable and showActivityComplete not defined
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginRight: '0.5em',
          width: '40px'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, title));
    });
    _defineProperty(_assertThisInitialized(_this), "toggleChange", function (activity) {
      _this.props.onActivityApplicableChange(activity);
    });
    _defineProperty(_assertThisInitialized(_this), "changeSessionHeld", function (held) {
      _this.setState({
        sessionHeld: held
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getHeldStatus", function () {
      if (_this.state.notSubmitted) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "--/--/--");
      }
      if (_this.props.session.held) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].held
        }, /*#__PURE__*/_react["default"].createElement(_circleSmall["default"], null)), "Held: ", _this.state.sessionDate.format('MM/DD/YYYY'));
      }
      if (!_this.props.session.held) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].missed
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Missed");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getHeldMissedContent", function (tabList) {
      if (_this.props.session.held === false && !_this.state.notSubmitted) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])('data-collection-body', _style["default"].bodyContainerMissed)
        }, /*#__PURE__*/_react["default"].createElement("div", null, _this.props.session.requireCalendarPicker !== false && !_this.state.calendarOpen && _this.props.isHeldMissed && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].backdrop
        }), _this.state.calendarOpen && /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
          sessionHeld: _this.state.sessionHeld,
          selectedDate: _this.state.calendarDate,
          changeSessionHeld: _this.changeSessionHeld,
          onDateSelect: _this.onDateSelect,
          onCalendarSubmit: _this.onCalendarSubmit,
          notSubmitted: _this.state.notSubmitted
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].sessionMissedModal
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingLeft: '0.5em',
            paddingRight: '0.5em'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].missedMessage
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Marked as missed"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].subText
        }, "Click the calendar icon above to change session status")))), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(_style["default"].tabContent, _cccisdStyleBible["default"].triangleNav)
        }, /*#__PURE__*/_react["default"].createElement(_tabs["default"], {
          tabList: tabList,
          orientation: "vertical",
          onTabSelect: _this.onSelectTab,
          activeTab: _this.props.currentActivity.handle,
          verticalTabWidths: _this.props.tabWidths
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "clearfix"
        })));
      }
      if (_this.props.session.held || _this.state.notSubmitted) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])('data-collection-body', _style["default"].bodyContainerHeld)
        }, _this.props.isHeldMissed && /*#__PURE__*/_react["default"].createElement("div", null, _this.state.calendarOpen && /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
          sessionHeld: _this.state.sessionHeld,
          selectedDate: _this.state.calendarDate,
          changeSessionHeld: _this.changeSessionHeld,
          onDateSelect: _this.onDateSelect,
          onCalendarSubmit: _this.onCalendarSubmit,
          notSubmitted: _this.state.notSubmitted,
          label: _this.props.session.label
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(_style["default"].tabContent, _cccisdStyleBible["default"].triangleNav)
        }, /*#__PURE__*/_react["default"].createElement(_tabs["default"], {
          tabList: tabList,
          orientation: "vertical",
          onTabSelect: _this.onSelectTab,
          activeTab: _this.props.currentActivity.handle,
          verticalTabWidths: _this.props.tabWidths
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "clearfix"
        })));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getNoHeldMissedContent", function (tabList) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-body', _style["default"].bodyContainerHeld)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].tabContent, _cccisdStyleBible["default"].triangleNav)
      }, /*#__PURE__*/_react["default"].createElement(_tabs["default"], {
        tabList: tabList,
        orientation: "vertical",
        onTabSelect: _this.onSelectTab,
        activeTab: _this.props.currentActivity.handle,
        verticalTabWidths: _this.props.tabWidths
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "getActivityProps", function (activity) {
      var initialValueSettings = {};
      if ((0, _has2["default"])(activity, 'withInitialValues') && activity.withInitialValues) {
        initialValueSettings = activity.initialValueSettings;
      }

      // Pass Props Here
      return {
        responseSet: _this.props.session.responseSet,
        onFlowComplete: _this.onFlowComplete,
        pawn: _this.props.pawn,
        onActivityFinished: _this.onActivityFinished,
        goToNextActivity: _this.props.onNextActivityClick,
        progress: activity.progress,
        flowVariables: 'flowVariables' in activity ? true : false,
        flowVarData: _this.props.session.varData,
        acrossChildren: 'acrossChildren' in activity ? true : false,
        acrossChildrenSettings: 'acrossChildren' in activity ? activity.acrossChildrenSettings : {},
        isLast: (0, _last2["default"])(_this.props.session.activities).handle === activity.handle,
        childList: 'acrossChildren' in activity ? (0, _get2["default"])(_this.props.pawn, activity.acrossChildrenSettings.childrenPath) : [],
        hasInitialValues: (0, _has2["default"])(activity, 'withInitialValues') ? activity.withInitialValues : false,
        initialValueSettings: initialValueSettings,
        hidePlayButton: 'hidePlayButton' in activity && activity.hidePlayButton ? true : false,
        isDeployment: 'isDeployment' in activity ? true : false,
        deploymentSettings: 'isDeployment' in activity ? activity.deploymentSettings : {}
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getSessionPicker", function (allSessions) {
      var filteredSessions = _this.props.sessions.filter(function (item) {
        return item.type === _this.props.session.type;
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontSize: '26px'
        }
      }, _this.props.session.subTitle), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
        style: {
          zIndex: 505,
          minWidth: '200px',
          whiteSpace: 'nowrap'
        },
        valueComponent: function valueComponent() {
          return /*#__PURE__*/_react["default"].createElement("div", null, _this.props.session.label, _this.props.session.complete && /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], {
            spaceLeft: true
          }));
        },
        valueField: "responseSet",
        data: filteredSessions,
        textField: "label",
        onChange: _this.jumpToSession,
        itemComponent: function itemComponent(_ref2) {
          var item = _ref2.item;
          return /*#__PURE__*/_react["default"].createElement("div", null, item.label, item.complete && /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], {
            spaceLeft: true
          }));
        }
      })));
    });
    _this.state = {
      calendarOpen: false,
      notSubmitted: false,
      calendarDate: (0, _moment["default"])(),
      sessionDate: (0, _moment["default"])(),
      sessionHeld: null
    };
    return _this;
  }
  _createClass(DataCollection, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var tabList = [];
      var allActivityProgress = {};
      // all activity progress
      this.props.session.activities.forEach(function (a) {
        allActivityProgress[a.handle] = a.progress;
      });

      // assumes flow right now
      this.props.session.activities.forEach(function (a) {
        // let Component = ContentContainers[a.type];
        var Component = _types["default"].flow;
        var omittedProgress = [];
        Object.keys((0, _omit2["default"])(allActivityProgress, ["".concat(a.handle)])).forEach(function (ok) {
          omittedProgress.push(allActivityProgress[ok]);
        });
        var content;
        if (a.applicable || a.progress.completed) {
          content = /*#__PURE__*/_react["default"].createElement(Component, _extends({
            key: a.handle,
            handle: a.handle,
            flowHandle: a.flowHandle,
            showNextButton: !(0, _isEmpty2["default"])((0, _filter2["default"])(omittedProgress, function (op) {
              return !op.completed;
            })),
            reportNode: _this2.props.reportNode,
            showReport: _this2.props.showReport
          }, _this2.getActivityProps(a)));
        } else {
          content = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].notApplicable
          }, "Activity Not Applicable");
        }
        tabList.push({
          name: a.handle,
          title: _this2.formatTitle(a.label, a),
          content: content
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.session.responseSet,
        className: (0, _classnames["default"])('data-collection-component', _style["default"].dataEntryContainer),
        ref: function ref(_ref3) {
          _this2.dataEntryDiv = _ref3;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-header', _style["default"].dataEntryHeader)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-content', _style["default"].dataEntryHeaderContent)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].flipper)
      }, !this.props.leftFlipperDisabled && /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this.goToPrevious
      }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-titleBox', _style["default"].titleBox)
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.getSessionPicker(sessions))), this.props.isHeldMissed && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-infoBox', _style["default"].sessionInfo)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginRight: '1em'
        }
      }, this.getHeldStatus()), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default btn-xs",
        onClick: this.onCalendarClick,
        disabled: this.props.requireCalendarPicker && this.props.session.date === null && this.state.calendarOpen
      }, /*#__PURE__*/_react["default"].createElement(_calendar["default"], null)))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].flipper)
      }, !this.props.rightFlipperDisabled && /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this.goToNext
      }, /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)))), this.props.isHeldMissed && this.getHeldMissedContent(tabList), !this.props.isHeldMissed && this.getNoHeldMissedContent(tabList)));
    }
  }]);
  return DataCollection;
}(_react["default"].Component);
_defineProperty(DataCollection, "propTypes", {
  /**
   * The data objects for the sessions or encounters
   * Example: [
   *     {
   *         handle: "session1",
   *         label: "Session 1",
   *         subTitle: "Anger Manangement",
   *         responseSet: 1,
   *         held: true
   *         activities: [
   *             {...},
   *             {...}
   *         ]
   *     }
   * ]
   */
  session: _propTypes["default"].object.isRequired,
  sessions: _propTypes["default"].array.isRequired,
  currentActivity: _propTypes["default"].object.isRequired,
  requireCalendarPicker: _propTypes["default"].bool,
  showActivityComplete: _propTypes["default"].bool,
  showActivityApplicable: _propTypes["default"].bool,
  canViewPreviousSession: _propTypes["default"].bool,
  onCalendarSubmit: _propTypes["default"].func,
  onFlipperBack: _propTypes["default"].func,
  onFlipperForward: _propTypes["default"].func,
  onActivityFinished: _propTypes["default"].func,
  onActivitySelect: _propTypes["default"].func,
  onActivityApplicableChange: _propTypes["default"].func,
  onNextActivityClick: _propTypes["default"].func,
  onJumpToSession: _propTypes["default"].func,
  // onDoneClick: PropTypes.func,

  leftFlipperDisabled: _propTypes["default"].bool,
  rightFlipperDisabled: _propTypes["default"].bool,
  pawn: _propTypes["default"].object,
  isHeldMissed: _propTypes["default"].bool,
  onFlowFinished: _propTypes["default"].func,
  isScrollTop: _propTypes["default"].bool,
  reportNode: _propTypes["default"].node,
  showReport: _propTypes["default"].bool,
  tabWidths: _propTypes["default"].object
});
_defineProperty(DataCollection, "defaultProps", {
  requireCalendarPicker: false,
  onCalendarSubmit: function onCalendarSubmit() {},
  onFlipperBack: function onFlipperBack() {},
  onFlipperForward: function onFlipperForward() {},
  onFlowFinished: function onFlowFinished() {},
  onActivitySelect: function onActivitySelect() {},
  onActivityApplicableChange: function onActivityApplicableChange() {},
  onNextActivityClick: function onNextActivityClick() {},
  onJumpToSession: function onJumpToSession() {},
  isHeldMissed: true,
  isScrollTop: true,
  showReport: false,
  tabWidths: {
    left: 3,
    right: 9
  }
});